import { render } from "./TraveldealsCom.vue?vue&type=template&id=a9732c96&scoped=true"
import script from "./TraveldealsCom.vue?vue&type=script&lang=js"
export * from "./TraveldealsCom.vue?vue&type=script&lang=js"

import "./TraveldealsCom.vue?vue&type=style&index=0&id=a9732c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9732c96"]])

export default __exports__